import styled, { CSSObject } from 'styled-components';
import { color_grey_17, font_montserrat, tabletPortrait } from '../global.styles';

interface H1Props {
  variant?: 'h2' | 'h1';
  color?: CSSObject['color'];
  letterSpacing?: string;
  margin?: string;
  textAlign?: string;
  fontSize?: string;
  mobileSize?: string;
  lineHeight?: string;
}
export const StyledH1 = styled('h1').withConfig({
  shouldForwardProp: (prop) => !['letterSpacing', 'textAlign', 'fontSize', 'mobileSize', 'lineHeight'].includes(prop),
})<H1Props>`
  font-size: ${(props) => {
    if (props['fontSize']) {
      return props['fontSize'];
    } else {
      switch (props['data-variant']) {
        case 'h1':
          return '56px';
        case 'h2':
          return '48px';
      }
    }
  }};
  color: ${(props) => props.color || color_grey_17};
  margin: ${(props) => props['data-margin'] || '0'};
  text-align: ${(props) => props.textAlign || 'start'};
  letter-spacing: ${(props) => props.letterSpacing || '-0.02em'};
  font-family: ${font_montserrat};
  line-height: ${(props) => {
    if (props['lineHeight']) {
      return props['lineHeight'];
    } else {
      switch (props['data-variant']) {
        case 'h1':
          return '1.23';
        case 'h2':
          return 'inherit';
      }
    }
  }};
  ${tabletPortrait} {
    font-size: ${(props) =>
      props.mobileSize || (props['data-variant'] === 'h1' ? '36px' : props['data-variant'] === 'h2' ? '30px' : '16px')};
  }
`;
